import StarRating from './star-rating'
import ImgixImg from '../imgix-img/connected'

export default ({ starNumber, value, EndIcon, variant }) => (
  <StarRating
    starsNumber={starNumber}
    variant={variant}
    EndIcon={<ImgixImg entity={EndIcon} />}
    value={value}
  />
)
